import { render, staticRenderFns } from "./TestReportTable.vue?vue&type=template&id=f2123baa&"
import script from "./TestReportTable.vue?vue&type=script&lang=ts&"
export * from "./TestReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./TestReportTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports